import { PageFilter } from '../state/app';
import { BrandRequestItem, BrandRequestItemListFilter } from '../state/brandRequestItem';
import { buildUrlSearchParams } from '../utils/apiRequestUtil';
import axios from '../utils/axios';

const baseUrl = `/api/brandRequestItems`;

export const fetchBrandRequestItemList = async ({
  filters,
  paging,
}: {
  filters: BrandRequestItemListFilter;
  paging: PageFilter;
}) => {
  const params = buildUrlSearchParams(filters, paging);
  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};

export const fetchBrandRequestItem = async (id: BrandRequestItem['id']) => {
  const requestUrl = `${baseUrl}/${id}`;
  return await axios.get(requestUrl);
};

export const createBrandRequestItem = async (brandRequestItem: BrandRequestItem) => {
  const requestUrl = `${baseUrl}`;
  return await axios.post(requestUrl, brandRequestItem);
};

export const updateBrandRequestItem = async (brandRequestItem: BrandRequestItem) => {
  const requestUrl = `${baseUrl}`;
  return await axios.put(requestUrl, brandRequestItem);
};

export const deleteBrandRequestItem = async (id: number) => {
  const requestUrl = `${baseUrl}/${id}`;
  return await axios.delete(requestUrl);
};
